export enum ProductLine {
  DEMAND_RESPONSE = 'DEMAND_RESPONSE',
  DEMAND_RESPONSE_NON_EVENT = 'DEMAND_RESPONSE_NON_EVENT',
  ENERGY_MANAGEMENT_SYSTEMS = 'ENERGY_MANAGEMENT_SYSTEMS'
}
